import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Bell, Check } from 'lucide-react';
import { toast } from 'sonner';
import apiClient from '@/utils/api';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

export const SectorAlertDialog = ({ sector, sectorLabel, open, onOpenChange }) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await apiClient.post('/alerts/sector/subscribe', { email, sector_slug: sector });
      setDone(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || t('sectorAlerts.error'));
    } finally {
      setSaving(false);
    }
  };

  const close = (v) => { onOpenChange(v); if (!v) { setDone(false); setEmail(''); } };

  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="sm:max-w-md" data-testid="sector-alert-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Bell className="h-5 w-5 text-blue-700" />{t('sectorAlerts.title', { sector: sectorLabel })}</DialogTitle>
          <DialogDescription>{t('sectorAlerts.description')}</DialogDescription>
        </DialogHeader>
        {done ? (
          <div className="flex items-start gap-3 rounded-lg bg-emerald-50 border border-emerald-200 p-4 text-emerald-900" data-testid="sector-alert-success">
            <Check className="h-5 w-5 mt-0.5" />
            <p className="text-sm">{t('sectorAlerts.success', { sector: sectorLabel })}</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t('sectorAlerts.emailPlaceholder')} data-testid="sector-alert-email" />
            <Button type="submit" disabled={saving} className="w-full" data-testid="sector-alert-submit">
              {saving ? t('sectorAlerts.saving') : t('sectorAlerts.subscribe')}
            </Button>
            <p className="text-xs text-slate-500">{t('sectorAlerts.privacy')}</p>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};
